var COORDINATE_LIMIT = 300000;

var DateLabelFormats = {
    milliseconds: "HH:mm:ss.fff",
    seconds: "HH:mm:ss",
    minutes: "HH:mm",
    hours: "HH:mm",
    days: "M/d",
    weeks: "M/d",
    months: "MMM 'yy",
    years: "yyyy"
};

var ZERO_THRESHOLD = 0.2;

export {
    COORDINATE_LIMIT, DateLabelFormats, ZERO_THRESHOLD
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/core/constants.js
// module id = 286
// module chunks = 29